/**
 * `site` — le réglage du site de galerie (base galerie, 4.1 ; D2).
 *
 * Un seul document par galerie.
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, langueSchema, withAudit } from './commun.js';
/**
 * Les trois thèmes standard, nommés en 3.4 et dérivés des maquettes de
 * `designs/`. Un site sur mesure est un quatrième thème, écrit pour la
 * galerie dans le même contrat de données.
 */
export const THEMES_SITE = ['cimaise', 'cartel', 'accrochage'];
export const themeSiteSchema = z.enum(THEMES_SITE);
/** Les blocs de la page d'accueil. */
export const TYPES_BLOC = [
    'heros',
    'oeuvres',
    'expositions',
    'actualites',
    'artistes',
    'texte',
    'contact',
];
export const typeBlocSchema = z.enum(TYPES_BLOC);
export const blocSchema = z.object({
    type: typeBlocSchema,
    titre: bilingueSchema.optional(),
    options: z.record(z.string(), z.unknown()).default({}),
});
export const charteSchema = z.object({
    logotypeMediaId: idSchema.optional(),
    couleurEncre: z.string().regex(/^#[0-9a-f]{6}$/i),
    couleurPapier: z.string().regex(/^#[0-9a-f]{6}$/i),
    couleurAccent: z.string().regex(/^#[0-9a-f]{6}$/i),
    policeTitre: z.string(),
    policeTexte: z.string(),
});
export const entreeMenuSchema = z.object({
    libelle: bilingueSchema,
    chemin: z.string().startsWith('/'),
    ordre: z.int().min(0).default(0),
});
/** Une redirection 301, posée quand un slug change (4.2). */
export const redirectionSchema = z.object({
    de: z.string().startsWith('/'),
    vers: z.string().startsWith('/'),
    code: z.literal(301).default(301),
    poseeLe: z.date(),
});
export const siteSchema = withAudit(z.object({
    _id: idSchema,
    theme: themeSiteSchema.default('cimaise'),
    charte: charteSchema,
    menus: z.array(entreeMenuSchema).default([]),
    langues: z.array(langueSchema).min(1).default(['fr']),
    accueil: z.array(blocSchema).default([]),
    mentionArtosera: z.boolean().default(true),
    redirections: z.array(redirectionSchema).default([]),
    dernierePublication: z.date().optional(),
    versionPubliee: z.string().optional(),
}));
export const siteMiseAJourSchema = siteSchema
    .omit({ ...CHAMPS_DOCUMENT, dernierePublication: true, versionPubliee: true })
    .partial();
//# sourceMappingURL=site.js.map